/**
 * Scroll Animations — initialises AOS (Animate On Scroll) library
 *
 * Configuration is passed from PHP via wp_localize_script() as AevumData.aos.
 * Elementor widget renders data-aos attributes on elements; AOS picks them up.
 */

import AOS from 'aos';
import 'aos/dist/aos.css';

export function initScrollAnimations() {
	const config = window.AevumData?.aos || {};

	AOS.init( {
		duration: config.duration ?? 800,
		once:     config.once     ?? true,
		offset:   config.offset   ?? 120,
		easing:   'ease',
		// Re-init AOS after Elementor front-end renders widgets.
		debounceDelay:  50,
		throttleDelay: 100,
	} );

	// Re-initialise when Elementor finishes loading widgets in the frontend.
	if ( window.elementorFrontend ) {
		window.elementorFrontend.hooks.addAction( 'frontend/element_ready/global', () => {
			AOS.refresh();
		} );
	}
}
